import {
    api_url,
    legendLabelsBoxHeightLine,
    configChartsColorPalettes,
    yRight,
    partSumpTrajectory,
    popupInformation,
    defaultBarPercentage,
    defaultDatalabelsProperties,
    defaultTicksCustomValue
} from "../../../utils";

const EmissionCo2Mode = {
    checked: false,
    titleSideBar: "Emission de CO2 par mode",
    titleIndicator: "SUMP Trajectory Content.charts.EmissionsCO2.title",
    popupInformation: {
        status: "false",
        text: popupInformation[partSumpTrajectory]["emissionCo2Mode"],
    },
    keyFigure: {
        typeUpdate: "year", // year or geographical_area
        label: "",
        url: "",
        separator: "",
        position: "",
    },
    charts: [
        {
            typeChart: "area",
            typeLabels: "geographical_areas", // years or geographical_areas
            multiYearGeographicalArea: true,
            singleYearGeographicalAreaType: "geographical_area", // year or geographical_area : MUST BE CONSISTENT WITH THE TYPE_LABEL ARGUMENT OF THE DATASET URL
            titleChart: "",
            titleDisplay: "true",
            legendDisplay: "true",
            legendCustom: "false",
            legendLabelsBoxHeight: legendLabelsBoxHeightLine,
            maintainAspectRatio: true,
            indexAxis: "x", // x or y
            heightChart: "350",
            widthChart: "600",
            i18nKeyLabels: "SUMP Trajectory Content.charts.EmissionsCO2.axis.labelsX",
            scales: {
                x: {
                    type: "category",
                    display: true,
                    stacked: true,
                    titleDisplay: false,
                    titleText: "",
                    gridDisplay: false,
                    beginAtZero: false,
                    ticks: {
                        display: true,
                        value: defaultTicksCustomValue
                    }
                },
                y: {
                    type: "linear",
                    display: true,
                    stacked: true,
                    titleDisplay: true,
                    titleText: "SUMP Trajectory Content.charts.EmissionsCO2.axis.titleY",
                    gridDisplay: true,
                    beginAtZero: true,
                    max: 1000000000,
                    ticks: {
                        display: true,
                        value: defaultTicksCustomValue
                    }
                },
                yRight: yRight,
            },
            annotationsProperties: {
                annotation1: undefined,
                annotation2: undefined
            },
            keyFigure: {
                typeUpdate: "year", // year or geographical_area
                label: "",
                url: "",
                separator: "",
                position: "",
            },
            datasets: [
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.EmissionsCO2.legend.HIDETOOLTIPIFZERORail",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=rabat_geographical_areas&indicator=emission_co2_mode&trend=reality&chart=emission_co2_mode_rail&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor: configChartsColorPalettes["trajectory_emissions_co2"].backgroundColor[0],
                    borderColor: configChartsColorPalettes["trajectory_emissions_co2"].borderColor[0],
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: 0.4,
                    datalabelsProperties: defaultDatalabelsProperties,
                },
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.EmissionsCO2.legend.HIDETOOLTIPIFZEROTram",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=rabat_geographical_areas&indicator=emission_co2_mode&trend=reality&chart=emission_co2_mode_tram&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
                    backgroundColor: configChartsColorPalettes["trajectory_emissions_co2"].backgroundColor[1],
                    borderColor: configChartsColorPalettes["trajectory_emissions_co2"].borderColor[1],
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: 0.4,
                    datalabelsProperties: defaultDatalabelsProperties,
                },
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.EmissionsCO2.legend.HIDETOOLTIPIFZEROBus",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=rabat_geographical_areas&indicator=emission_co2_mode&trend=reality&chart=emission_co2_mode_bus&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor: configChartsColorPalettes["trajectory_emissions_co2"].backgroundColor[2],
                    borderColor: configChartsColorPalettes["trajectory_emissions_co2"].borderColor[2],
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: 0.4,
                    datalabelsProperties: defaultDatalabelsProperties,
                },
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.EmissionsCO2.legend.HIDETOOLTIPIFZEROGT",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=rabat_geographical_areas&indicator=emission_co2_mode&trend=reality&chart=emission_co2_mode_gt&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor: configChartsColorPalettes["trajectory_emissions_co2"].backgroundColor[3],
                    borderColor: configChartsColorPalettes["trajectory_emissions_co2"].borderColor[3],
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: 0.4,
                    datalabelsProperties: defaultDatalabelsProperties,
                },
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.EmissionsCO2.legend.HIDETOOLTIPIFZEROPT",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=rabat_geographical_areas&indicator=emission_co2_mode&trend=reality&chart=emission_co2_mode_pt&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor: configChartsColorPalettes["trajectory_emissions_co2"].backgroundColor[4],
                    borderColor: configChartsColorPalettes["trajectory_emissions_co2"].borderColor[4],
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: 0.4,
                    datalabelsProperties: defaultDatalabelsProperties,
                },
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.EmissionsCO2.legend.HIDETOOLTIPIFZEROVoiture",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=rabat_geographical_areas&indicator=emission_co2_mode&trend=reality&chart=emission_co2_mode_voiture&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor: configChartsColorPalettes["trajectory_emissions_co2"].backgroundColor[5],
                    borderColor: configChartsColorPalettes["trajectory_emissions_co2"].borderColor[5],
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: 0.4,
                    datalabelsProperties: defaultDatalabelsProperties,
                },
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.EmissionsCO2.legend.HIDETOOLTIPIFZEROMotos",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=rabat_geographical_areas&indicator=emission_co2_mode&trend=reality&chart=emission_co2_mode_motos&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor: configChartsColorPalettes["trajectory_emissions_co2"].backgroundColor[6],
                    borderColor: configChartsColorPalettes["trajectory_emissions_co2"].borderColor[6],
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: 0.4,
                    datalabelsProperties: defaultDatalabelsProperties,
                },
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.EmissionsCO2.legend.HIDELEGENDHIDETOOLTIPIFZERORail",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=rabat_geographical_areas&indicator=emission_co2_mode&trend=reality&chart=emission_co2_mode_rail_objective&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor: configChartsColorPalettes["trajectory_emissions_co2_objective_transparency"].backgroundColor[0],
                    borderColor: configChartsColorPalettes["trajectory_emissions_co2_objective_transparency"].borderColor[0],
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: 0.4,
                    datalabelsProperties: defaultDatalabelsProperties,
                },
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.EmissionsCO2.legend.HIDELEGENDHIDETOOLTIPIFZEROTram",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=rabat_geographical_areas&indicator=emission_co2_mode&trend=reality&chart=emission_co2_mode_tram_objective&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
                    backgroundColor: configChartsColorPalettes["trajectory_emissions_co2_objective_transparency"].backgroundColor[1],
                    borderColor: configChartsColorPalettes["trajectory_emissions_co2_objective_transparency"].borderColor[1],
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: 0.4,
                    datalabelsProperties: defaultDatalabelsProperties,
                },
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.EmissionsCO2.legend.HIDELEGENDHIDETOOLTIPIFZEROBus",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=rabat_geographical_areas&indicator=emission_co2_mode&trend=reality&chart=emission_co2_mode_bus_objective&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor: configChartsColorPalettes["trajectory_emissions_co2_objective_transparency"].backgroundColor[2],
                    borderColor: configChartsColorPalettes["trajectory_emissions_co2_objective_transparency"].borderColor[2],
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: 0.4,
                    datalabelsProperties: defaultDatalabelsProperties,
                },
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.EmissionsCO2.legend.HIDELEGENDHIDETOOLTIPIFZEROGT",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=rabat_geographical_areas&indicator=emission_co2_mode&trend=reality&chart=emission_co2_mode_gt_objective&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor: configChartsColorPalettes["trajectory_emissions_co2_objective_transparency"].backgroundColor[3],
                    borderColor: configChartsColorPalettes["trajectory_emissions_co2_objective_transparency"].borderColor[3],
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: 0.4,
                    datalabelsProperties: defaultDatalabelsProperties,
                },
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.EmissionsCO2.legend.HIDELEGENDHIDETOOLTIPIFZEROPT",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=rabat_geographical_areas&indicator=emission_co2_mode&trend=reality&chart=emission_co2_mode_pt_objective&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor: configChartsColorPalettes["trajectory_emissions_co2_objective_transparency"].backgroundColor[4],
                    borderColor: configChartsColorPalettes["trajectory_emissions_co2_objective_transparency"].borderColor[4],
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: 0.4,
                    datalabelsProperties: defaultDatalabelsProperties,
                },
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.EmissionsCO2.legend.HIDELEGENDHIDETOOLTIPIFZEROVoiture",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=rabat_geographical_areas&indicator=emission_co2_mode&trend=reality&chart=emission_co2_mode_voiture_objective&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor: configChartsColorPalettes["trajectory_emissions_co2_objective_transparency"].backgroundColor[5],
                    borderColor: configChartsColorPalettes["trajectory_emissions_co2_objective_transparency"].borderColor[5],
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: 0.4,
                    datalabelsProperties: defaultDatalabelsProperties,
                },
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.EmissionsCO2.legend.HIDELEGENDHIDETOOLTIPIFZEROMotos",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=rabat_geographical_areas&indicator=emission_co2_mode&trend=reality&chart=emission_co2_mode_motos_objective&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor: configChartsColorPalettes["trajectory_emissions_co2_objective_transparency"].backgroundColor[6],
                    borderColor: configChartsColorPalettes["trajectory_emissions_co2_objective_transparency"].borderColor[6],
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: 0.4,
                    datalabelsProperties: defaultDatalabelsProperties,
                },
            ],
        },
    ],
};

export default EmissionCo2Mode;
